/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SampleContainerType from './sample-container-type';
import SampleContainerTypeDetail from './sample-container-type-detail';
import SampleContainerTypeUpdate from './sample-container-type-update';
import SampleContainerTypeDeleteDialog from './sample-container-type-delete-dialog';

const SampleContainerTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SampleContainerType />} />
    <Route path="new" element={<SampleContainerTypeUpdate />} />
    <Route path=":id">
      <Route index element={<SampleContainerTypeDetail />} />
      <Route path="edit" element={<SampleContainerTypeUpdate />} />
      <Route path="delete" element={<SampleContainerTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SampleContainerTypeRoutes;
